import React from 'react'
import SeoMetaData from '@/components/SeoMetaData'

export default function Husvet2026() {
  // The site header is sticky (60px) and footer is fixed.
  // We reserve room so the iframe content doesn't hide behind the footer.
  return (
    <>
      <SeoMetaData
        seoTitle="Húsvéti Labirintus | BeArt Művészetterápia"
        seoDescription="Játssz a Húsvéti Labirintus játékot a BeArt oldalon: gyűjtsd össze a tojásokat és répákat, és fesd ki az egg-eket!"
      />

      <div className="h-[calc(100dvh-60px-64px)] w-full overflow-hidden">
        <iframe
          title="Húsvéti Labirintus"
          src="/husvet2026-game/index.html"
          className="h-full w-full border-0"
        />
      </div>
    </>
  )
}

